import { CareerId } from '@common/const/catalog/career';
import { ClientType } from '@common/model/client/clientType';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import React from 'react';
import { CLIENT_ADDRESS_SEARCH_MODAL_NAME } from 'src/app/shared/components/modals/clientAddressSearch/const';
import { RELEVANT_SPECIALISTS_MODAL_NAME } from 'src/app/shared/components/modals/relevantSpecialists/const';
import { useModal } from 'src/shared/modalProvider';

export interface IPreFilterRegistrationProps {
  careerId: CareerId; // TODO: switch to optional and add career selection modal opening
}

const catalogType = clientTypeToSuitableCatalogItemType(ClientType.Employer);

export const useEmployerPreFilterRegistration = () => {
  const { openModal } = useModal();

  return React.useCallback(
    (props: IPreFilterRegistrationProps) => {
      const { careerId } = props;

      openModal(CLIENT_ADDRESS_SEARCH_MODAL_NAME, {
        careerId,
        catalogType,
        onAddressConfirmed: ({ city }) => {
          openModal(RELEVANT_SPECIALISTS_MODAL_NAME, {
            careerId,
            cityId: city.id,
            catalogType,
          });
        },
      });
    },
    [openModal],
  );
};
